var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgTwitter = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("g", {
    clipPath: "url(#clip0_2667_4535)"
  }, React.createElement("path", {
    d: "M4.66667 1C2.64773 1 1 2.64773 1 4.66667V19.3333C1 21.3523 2.64773 23 4.66667 23H19.3333C21.3523 23 23 21.3523 23 19.3333V4.66667C23 2.64773 21.3523 1 19.3333 1H4.66667ZM4.66667 2.04762H19.3333C20.7862 2.04762 21.9524 3.21379 21.9524 4.66667V19.3333C21.9524 20.7862 20.7862 21.9524 19.3333 21.9524H4.66667C3.21379 21.9524 2.04762 20.7862 2.04762 19.3333V4.66667C2.04762 3.21379 3.21379 2.04762 4.66667 2.04762ZM5.7593 5.71429L10.5902 12.578L5.71429 18.2857H7.02381L11.1815 13.418L14.6068 18.2857H18.7645L13.4609 10.7498L17.7619 5.71429H16.4524L12.8696 9.90988L9.91704 5.71429H5.7593ZM7.76451 6.76191H9.3697L16.7593 17.2381H15.1541L7.76451 6.76191Z",
    fill: props.color || 'currentColor'
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_2667_4535"
  }, React.createElement("rect", {
    width: 22,
    height: 22,
    fill: props.color || 'currentColor',
    transform: "translate(1 1)"
  }))));
};
export default SvgTwitter;